"use client";

import { Compass, Stamp, Scale, FileText, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Trattamenti() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const primaryServices = [{
    numeral: "i",
    title: "Ostetricia",
    description: "Assistenza completa durante la gravidanza, il parto e il puerperio con un approccio basato sull'evidenza scientifica.",
    Icon: Compass
  }, {
    numeral: "ii",
    title: "Ginecologia",
    description: "Prevenzione, diagnosi e cura delle patologie dell'apparato riproduttivo femminile in ogni fase della vita.",
    Icon: Stamp
  }, {
    numeral: "iii",
    title: "Riproduzione Umana",
    description: "Consulenza specialistica e percorsi personalizzati per la diagnosi e il trattamento dell'infertilità di coppia.",
    Icon: Scale
  }];
  const secondaryServices = [{
    numeral: "iv",
    title: "Ginecologia Forense",
    description: "Consulenza tecnica di parte e peritale in ambito medico-legale per la tutela dei diritti in ambito ginecologico.",
    Icon: FileText,
    span: "lg:col-span-7"
  }, {
    numeral: "v",
    title: "Fisiopatologia",
    description: "Studio approfondito delle alterazioni funzionali dell'apparato riproduttivo per soluzioni terapeutiche mirate.",
    Icon: Briefcase,
    span: "lg:col-span-5"
  }];
  return <section data-section-id="3568" id="trattamenti-e-tecnologie" className="bg-slate-50 text-slate-900 py-24 md:py-36">
      <div className="container mx-auto px-6 md:px-10">
        {}
        <div ref={header.ref} className={`grid grid-cols-12 gap-6 md:gap-10 mb-20 md:mb-28 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="col-span-12 md:col-span-3">
            <span className="font-sans text-xs uppercase tracking-[0.25em] text-slate-600">
              03 — Specializzazioni
            </span>
          </div>
          <div className="col-span-12 md:col-span-9 lg:col-span-8">
            <h2 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-slate-900">
              Ambiti di <em className="italic text-blue-700">Competenza</em>
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10 md:mb-12">
          {primaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-white text-slate-900 border border-slate-200 rounded-lg p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${i === 1 ? "md:mt-[60px]" : ""}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-blue-600" strokeWidth={1.25} />
                  <span className="font-default italic text-base text-slate-500 tracking-wide">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default text-2xl md:text-[1.75rem] leading-tight text-slate-900 mb-4">
                  {service.title}
                </h3>

                <p className="font-sans text-sm md:text-base text-slate-600 leading-relaxed mb-10">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to="/ProfilePage" className="inline-flex items-center gap-2 font-default italic text-base text-slate-900 group/link">
                    <span className="relative">
                      Approfondisci
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-slate-900 transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1.5} />
                  </Link>
                </div>
              </article>;
        })}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {secondaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-white text-slate-900 border border-slate-200 rounded-lg p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${service.span}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-blue-600" strokeWidth={1.25} />
                  <span className="font-default italic text-base text-slate-500 tracking-wide">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default text-2xl md:text-[1.75rem] leading-tight text-slate-900 mb-4">
                  {service.title}
                </h3>

                <p className="font-sans text-sm md:text-base text-slate-600 leading-relaxed mb-10 max-w-xl">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to="/ForensicGynecologyPage" className="inline-flex items-center gap-2 font-default italic text-base text-slate-900 group/link">
                    <span className="relative">
                      Approfondisci
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-slate-900 transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1.5} />
                  </Link>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}